import { useState } from 'react';
import { Browser } from './Browser';
import { ChannelRack } from './ChannelRack';

/** Left panel: rack and browser tabs. */
export function LeftPanel() {
  const [tab, setTab] = useState<'rack' | 'browser'>('rack');

  return (
    <aside className="panel panel-left">
      <div className="panel-title">
        <span className="view-tabs">
          <button className={tab === 'rack' ? 'active' : ''} onClick={() => setTab('rack')}>
            Rack
          </button>
          <button className={tab === 'browser' ? 'active' : ''} onClick={() => setTab('browser')}>
            Browser
          </button>
        </span>
      </div>
      {tab === 'rack' ? <ChannelRack /> : <Browser />}
    </aside>
  );
}